import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IInvoice, IOrder } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/orders';
const $urlActionsRefund = '/admin/orders/actions/refund';
const $urlActionsGetInvoice = '/admin/orders/actions/getInvoice';

interface IGetRequest {
  status: string;
}

interface IGetResult {
  items: IOrder[];
  allCount: number;
  defaultCount: number;
  invoicedCount: number;
  refundedCount: number;
}

interface IRefundRequest {
  orderId: string;
}

interface IGetInvoiceRequest {
  invoiceId: string;
}

interface IGetInvoiceResult {
  invoice: IInvoice;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  getInvoice(req: IGetInvoiceRequest, success: (res: IGetInvoiceResult) => void) {
    utils.loading(true);
    request
      .get($urlActionsGetInvoice, {
        params: req,
      })
      .then((response: AxiosResponse<IGetInvoiceResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  refund(req: IRefundRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlActionsRefund, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
